import React from "react";
import { IoCloseSharp } from "react-icons/io5";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import GeneralButton from "../button/GeneralButton";
import { DropdownLabel } from "../dropdown/DropdownLabel";
import { purchaseCompanies } from "../../data";
import toast from "react-hot-toast";
const SelectServiceCarrierModal = ({
  modal,
  toggle,
  carrier,
  setCarrier,
  quotesResponse,
}) => {
  return (
    <Modal isOpen={modal} toggle={toggle} centered size="lg">
      <ModalBody className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h2 className="primary-color">Select Carrier Company</h2>
          <IoCloseSharp size={"30"} onClick={toggle} />
        </div>
        <Row>
          <Col md={12}>
            <DropdownLabel
              customClassName={"inner_style"}
              placeholder={"Select Carrier Company"}
              options={purchaseCompanies?.map((i) => i.label)}
              className={"drop_down_label_style w-100"}
              value={carrier}
              onSelect={(e, value) => {
                const selectedCarrier = value.children.toUpperCase();
                if (
                  selectedCarrier === "FEDEX" &&
                  typeof quotesResponse?.fedex === "string"
                ) {
                  toast.error(quotesResponse?.fedex);
                  setCarrier(value.children);
                } else if (
                  selectedCarrier === "UPS" &&
                  typeof quotesResponse?.ups === "string"
                ) {
                  toast.error(quotesResponse?.ups);
                  setCarrier(value.children);
                } else if (
                  selectedCarrier === "UPS" &&
                  typeof quotesResponse?.ups === "string"
                ) {
                  toast.error(quotesResponse?.usps);
                  setCarrier(value.children);
                } else {
                  setCarrier(value.children);
                  toggle();
                }
              }}
            />
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};
export default SelectServiceCarrierModal;
